import { LookupDictionary } from "@/Common/Models/LookupDictionary";

function toLookupDictionary<T>(items: T[], getKey: (item: T) => string): LookupDictionary<T> {
    return new LookupDictionary<T>(getKey, items);
}

export { toLookupDictionary };
